// extracted by mini-css-extract-plugin
export default {"card":"OptionCard_card__1jeuO","top":"OptionCard_top__ZQVR6","icon":"OptionCard_icon__VDJ-0","body":"OptionCard_body__w5QS3","title":"OptionCard_title__lbTY9"};